import { Component } from '@angular/core'
import { MatIcon } from '@angular/material/icon'
import { HeadingDirective } from '../../domains/ui/directives'

@Component({
    selector: 'app-no-connection',
    standalone: true,
    templateUrl: './no-connection.component.html',
    imports: [
        MatIcon,
        HeadingDirective,
    ],
    styleUrl: './no-connection.component.scss',
})
export class NoConnectionComponent {

}
